<div class="produto-faq">
      <div class="title">
            <h3>Dúvidas Frequentes</h3>
      </div>
      <div class="item" *ngFor="let d of data">
            <duvida-item [data]="d"></duvida-item>
      </div>  
</div>
